import { render, staticRenderFns } from "./importNewPerson.vue?vue&type=template&id=2a3815d8&scoped=true"
import script from "./importNewPerson.vue?vue&type=script&lang=js"
export * from "./importNewPerson.vue?vue&type=script&lang=js"
import style0 from "./importNewPerson.vue?vue&type=style&index=0&id=2a3815d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2a3815d8",
  null
  
)

export default component.exports